import { useState, useRef } from "react";

export function Base64() {
  const [inputText, setInputText] = useState("");
  const [outputText, setOutputText] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  function copyToClipboard() {
    navigator.clipboard.writeText(outputText);
  }

  function encode() {
    if (!inputText) return;
    const encoded = btoa(inputText);
    setOutputText(encoded);
  }

  function decode() {
    if (!inputText) return;
    try {
      const decoded = atob(inputText);
      setOutputText(decoded);
    } catch (e) {
      setOutputText("Invalid Base64 string");
    }
  }

  function handleInputChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    setInputText(e.target.value);
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      if (textareaRef.current.clientHeight < textareaRef.current.scrollHeight) {
        textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
      }
    }
  }

  return (
    <div style={{
      maxWidth: '600px',
      margin: '0 auto',
      padding: '20px',
      backgroundColor: '#f9f9f9',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{
        textAlign: 'center',
        color: '#333',
        marginBottom: '20px',
        fontSize: '24px'
      }}>
        Base64 Encoder/Decoder
      </h1>
      
      <div style={{
        display: 'flex',
        gap: '10px',
        justifyContent: 'center',
        marginBottom: '20px'
      }}>
        <button
          onClick={encode}
          style={{
            padding: '10px 20px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#45a049'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#4CAF50'}
        >
          Encode
        </button>
        <button
          onClick={decode}
          style={{
            padding: '10px 20px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1976D2'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2196F3'}
        >
          Decode
        </button>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontWeight: 'bold',
          color: '#555'
        }}>
          Input Text:
        </label>
        <textarea
          ref={textareaRef}
          placeholder="Enter text to encode or decode..."
          value={inputText}
          onChange={handleInputChange}
          style={{
            width: '90%',
            minHeight: '100px',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            resize: 'vertical',
            fontSize: '16px',
            fontFamily: 'inherit',
            outline: 'none',
            transition: 'border-color 0.3s'
          }}
          onFocus={(e) => e.currentTarget.style.borderColor = '#4CAF50'}
          onBlur={(e) => e.currentTarget.style.borderColor = '#ccc'}
        />
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontWeight: 'bold',
          color: '#555'
        }}>
          Output Text:
        </label>
        <textarea
          placeholder="Output will appear here..."
          value={outputText}
          onChange={(e) => setOutputText(e.target.value)}
          readOnly
          style={{
            width: '90%',
            minHeight: '100px',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            resize: 'vertical',
            fontSize: '16px',
            fontFamily: 'inherit',
            backgroundColor: '#f5f5f5',
            outline: 'none',
            color: 'black'
          }}
        />
      </div>

      <div style={{ textAlign: 'center' }}>
        <button
          onClick={copyToClipboard}
          style={{
            padding: '10px 20px',
            backgroundColor: '#FF9800',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#E68900'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#FF9800'}
        >
          Copy Output
        </button>
      </div>
    </div>
  );
}